// extracted by mini-css-extract-plugin
export var cardSquare = "CareersCard-module--card-square--bfc63";
export var careersCard = "CareersCard-module--careers-card--28489";